import { render, staticRenderFns } from "./diploma.vue?vue&type=template&id=e133e65c&scoped=true"
import script from "./diploma.vue?vue&type=script&lang=js"
export * from "./diploma.vue?vue&type=script&lang=js"
import style0 from "./diploma.vue?vue&type=style&index=0&id=e133e65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e133e65c",
  null
  
)

export default component.exports